import { render } from "./AccountsModal.vue?vue&type=template&id=415738c5&ts=true"
import script from "./AccountsModal.vue?vue&type=script&lang=ts"
export * from "./AccountsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__